<template>
  <div class="date-panel-2">
    <input
      type="text"
      v-model="currentDate"
      class="selectedDate"
      placeholder="请选择日期范围"
      @click="openDatePanel"
      readonly
      :disabled="disabledInput"
      :class="{ disable: disabledInput }"
    />
    <div class="finallyDate" v-if="finallyDate.length > 0">
      <p>当前的推广周期：</p>
      <div class="final-date-box">
        <p v-for="(date, index) in finallyDate" :key="index">{{ date }}</p>
      </div>
    </div>
    <transition name="slide">
      <div class="date-range2" v-show="showPanel">
        <div class="wrapper">
          <div class="dateWrapper">
            <div class="clearfix">
              <dateTable
                class="fl borderRight"
                :date="beginDate"
                :newDate="newLastDate"
                :disabledDate="dateDisableCopy"
                :checkedDateArray="arrDate"
                :disabledTime="disabledTime"
                @selected="selectDate"
                @goLastMonth="goLastMonth"
              ></dateTable>
              <dateTable
                class="fl"
                monthType="nextMonth"
                :date="finishDate"
                :newDate="newNextDate"
                @selected="selectDate"
                :checkedDateArray="arrDate"
                :disabledTime="disabledTime"
                @goNextMonth="goNextMonth"
                :disabledDate="dateDisableCopy"
              ></dateTable>
            </div>
          </div>
          <div class="timeSelect">
            <timeRange
              :selectedTime="selectedTime"
              @checkedTime="checkedTime"
              @deleteTime="deleteTime"
              :dateDisable="dateDisableCopy"
              :dateArray="arrDate"
              :pageType="pageType"
              :type24="type24"
              :receiveTime="receiveData"
              :defaultDate="defaultDate"
              :pageInfo="pageInfo"
              :disabledTime="disabledTime"
            ></timeRange>
          </div>
        </div>
        <p class="btnGroup date-range-btn clearfix">
          <el-button @click="clearDate">取消</el-button>
          <el-button @click="sendDateRange">确定</el-button>
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  formatDate,
  getDiffDate,
  getMonthDays,
  getAllGapDate
} from "../util/date";
import dateTable from "./date-table.vue";
import timeRange from "./time-range.vue";
export default {
  data () {
    return {
      beginDate: "",
      finishDate: getDiffDate(1, { type: "month" }).endDate,
      currentDate: [],
      newLastDate: [],
      newNextDate: [],
      showPanel: false,
      arrDate: [],
      startDay: "",
      allDate: [],
      successDate: [],
      selectedTime: [],
      finallyDate: [],
      dateDisableCopy: this.dateDisable,
      flag: false // 在编辑时，标识第一次赋值时间
    };
  },
  watch: {
    dateDisable(val) {
      this.dateDisableCopy = val
    }
  },
  props: {
    defaultDate: {
      // 设置可选的日期范围
      type: Array,
      default: () => {
        return [];
      }
    },
    dateDisable: {
      type: Function,
      default: time => {
        return new Date(time).getTime() < new Date().getTime() - 8.64e7;
      }
    },
    disabledInput: {
      type: Boolean,
      default: false
    },
    controlTime: {
      type: Boolean,
      default: false
    },
    disabledTime: {
      type: Object,
      default: () => ({})
    },
    disabledType: {
      required: false,
      type: Boolean,
      default: false
    },
    type24: {
      type: Boolean,
      default: true
    },
    receiveData: {
      // 设置已经选择的时间范围
      type: Array,
      default: () => {
        return [];
      }
    },
    receiveDateRange: {
      // 设置已经选择的日期范围
      type: Array,
      default: () => {
        return [];
      }
    },
    pageType: {
      // 判断页面是编辑还是查看还是新增
      type: String
    },
    pageInfo: {
      // 判断当前页面是计划相关还是广告相关
      type: String,
      default: ""
    }
  },
  mounted () {
    if (this.receiveData.length > 0) {
      this.successDate = this.receiveData;
      this.setDisabledDate(this.defaultDate);
      this.finallyDate = this.timeFormat(this.receiveData);
      this.receiveData.forEach(v => {
        this.selectDate(v.date, "edit");
      });
    }
    if (this.receiveDateRange.length > 0) {
      this.arrDate.splice(0, this.arrDate.length, ...this.receiveDateRange);
    }
  },
  methods: {
    deleteTime ({ index, date }) {
      this.selectedTime.splice(index, 1);
      this.setDate(date);
    },
    goLastMonth (year, month) {
      this.newNextDate.splice(0, 2, year, month);
    },
    goNextMonth (year, month) {
      this.newLastDate = [year, month];
    },
    openDatePanel () {
      this.showPanel = !this.showPanel;
    },
    clearDate () {
      this.currentDate = [];
      this.arrDate = [];
      this.selectedTime = [];
      this.finallyDate = [];
      this.showPanel = false;
      this.successDate = [];
      this.$emit("selectedCycle", {
        date: this.successDate,
        formatDate: this.timeFormat(this.successDate),
        dateCycle: this.arrDate
      });
    },
    deepClone (obj) {
      let clone = Object.assign({}, obj);
      Object.keys(clone).forEach(
        key =>
          (clone[key] =
            typeof obj[key] === "object" ? this.deepClone(obj[key]) : obj[key])
      );
      return Array.isArray(obj)
        ? (clone.length = obj.length) && Array.from(clone)
        : clone;
    },
    selectDate (date, pageType) {
      let self = this;
      let middleArray = [];
      let sortArray = [];
      this.setDate(date);
      if (pageType === "edit") {
        this.startDay = "";
      }
      this.arrDate.forEach(date => {
        middleArray.push(...getAllGapDate(date[0], date[1]));
      });
      middleArray = this.uniq(middleArray);
      middleArray.forEach(v => {
        sortArray.push(new Date(v));
      });
      sortArray = sortArray.sort(self.sequence);
      sortArray = sortArray.filter(arr => {
        // return true
        // return arr.getTime() >= new Date().getTime() - 8.64e7;
        return !this.dateDisableCopy(arr)
      });
      this.allDate = [];
      sortArray.forEach(v => {
        self.allDate.push(formatDate(v));
      });
      if (this.controlTime) {
        // this.selectedTime
      } else {
        let newArray = [];
        let oldArray = [];
        if (this.defaultDate.length > 0) {
          this.defaultDate.forEach(v1 => {
            this.allDate.forEach(v2 => {
              if (v1.date === v2) {
                oldArray.push(v1);
              }
            });
          });
        }
        // newArray = oldArray
        newArray = this.deepClone(oldArray);
        this.selectedTime = [];
        this.allDate.forEach((v, i) => {
          const curr = new Date(v);
          const now = new Date();
          const isSameDay =
            curr.getDate() === now.getDate() &&
            curr.getMonth() === now.getMonth() &&
            curr.getFullYear() === now.getFullYear();
          let minTime = isSameDay && this.dateDisableCopy(curr.getTime() - 3600 * 24 * 1000)
            ? now.getHours() < 10
              ? "0" + now.getHours()
              : now.getHours()
            : "00";
          if (this.defaultDate.length > 0) {
            if (this.disabledType) {
              let self = this;
              if (newArray.length) {
                if (!newArray.some(v1 => v1.date === v)) {
                  this.selectedTime.push({
                    date: v,
                    time: [[minTime, "23"]]
                  });
                }
              } else {
                self.selectedTime.push({
                  date: v,
                  time: [[minTime, "23"]]
                });
              }
            } else {
              if (newArray[i]) {
                newArray[i].time.forEach(v => {
                  v[1] = parseInt(v[1]) - 1 + "";
                });
                self.selectedTime.push({
                  date: v,
                  time: [[minTime, "23"]]
                });
                /*  this.selectedTime.push({
                   date: v,
                   time: newArray[i].time
                 }) */
              }
            }
          } else {
            this.selectedTime.push({
              date: v,
              time: [[minTime, "23"]]
            });
          }
        });
      }
    },
    selectFDate (date) {
      this.finishDate = date;
    },
    deleteCheckedDate (day, start, end, index) {
      let startDate = start;
      let endDate = end;
      let last = "";
      let next = "";
      let curYear = new Date(day).getFullYear();
      let curDay = new Date(day).getDate();
      let curMonth = new Date(day).getMonth() + 1;
      let endDay = getMonthDays(curYear, curMonth);
      if (curDay === 1) {
        last =
          new Date(day).getFullYear() +
          "-" +
          (curMonth - 1 < 10 ? "0" + parseInt(curMonth - 1) : curMonth - 1) +
          "-" +
          parseInt(endDay);
        next =
          new Date(day).getFullYear() +
          "-" +
          (curMonth < 10 ? "0" + curMonth : curMonth) +
          "-" +
          "02";
      } else if (curDay === endDay) {
        last =
          new Date(day).getFullYear() +
          "-" +
          (curMonth < 10 ? "0" + curMonth : curMonth) +
          "-" +
          (parseInt(endDay) - 1);
        next =
          new Date(day).getFullYear() +
          "-" +
          (curMonth + 1 < 10 ? "0" + parseInt(curMonth + 1) : curMonth + 1) +
          "-" +
          "01";
      } else {
        last =
          new Date(day).getFullYear() +
          "-" +
          (curMonth < 10 ? "0" + curMonth : curMonth) +
          "-" +
          (curDay - 1 < 10 ? "0" + parseInt(curDay - 1) : curDay - 1);
        next =
          new Date(day).getFullYear() +
          "-" +
          (curMonth < 10 ? "0" + curMonth : curMonth) +
          "-" +
          (curDay + 1 < 10 ? "0" + parseInt(curDay + 1) : curDay + 1);
      }
      this.arrDate.splice(index, 1);
      if (day === startDate && day !== endDate) {
        this.arrDate.push([next, endDate]);
      } else if (day === endDate && day !== startDate) {
        this.arrDate.push([startDate, last]);
      } else if (day !== startDate && day !== endDate) {
        this.arrDate.push([startDate, last], [next, endDate]);
      }
    },
    setDate (day) {
      let params = this.checkDay(day);
      // 获取时间段
      if (this.arrDate.length > 0) {
        if (this.startDay && day === this.startDay) {
          this.arrDate.push([day, this.startDay]);
          this.startDay = "";
        } else if (params.flag) {
          // 删除
          this.deleteCheckedDate(
            day,
            params.date[0],
            params.date[1],
            params.index
          );
        } else if (this.startDay) {
          if (new Date(this.startDay).getTime() > new Date(day).getTime()) {
            this.arrDate.push([day, this.startDay]);
          } else {
            this.arrDate.push([this.startDay, day]);
          }
          this.startDay = "";
        } else {
          this.startDay = day;
        }
      } else {
        if (this.startDay) {
          if (new Date(this.startDay).getTime() > new Date(day).getTime()) {
            this.arrDate.push([day, this.startDay]);
          } else {
            this.arrDate.push([this.startDay, day]);
          }
          this.startDay = "";
        } else {
          this.startDay = day;
        }
      }
    },
    // 判断日期是否在 arrDate内 或者是否小于当前的日期
    checkDay (day) {
      let params = {
        flag: false,
        date: [],
        index: 0
      };
      for (let i = 0; i < this.arrDate.length; i++) {
        if (
          new Date(day).getTime() >= new Date(this.arrDate[i][0]).getTime() &&
          new Date(day).getTime() <= new Date(this.arrDate[i][1]).getTime()
        ) {
          params.flag = true;
          params.date = [this.arrDate[i][0], this.arrDate[i][1]];
          params.index = i;
        }
      }
      return params;
    },
    // 数组去重
    uniq (array) {
      let temp = [];
      let index = [];
      let l = array.length;
      for (let i = 0; i < l; i++) {
        for (let j = i + 1; j < l; j++) {
          if (array[i] === array[j]) {
            i++;
            j = i;
          }
        }
        temp.push(array[i]);
        index.push(i);
      }
      return temp;
    },
    // 日期排序
    sequence (a, b) {
      return a - b;
    },
    // 最终选择的时间
    checkedTime (value) {
      this.successDate = value;
    },
    // 格式化已选择的日期时间 用于显示
    timeFormat (array) {
      // 2018-10-12 00:00:00~23:00:00
      let timeArray = [];
      array.forEach(v => {
        let hour = "";
        v.time.forEach(h => {
          hour += h[0] + ":00~" + h[1] + ":00 ";
        });
        timeArray.push(v.date + "：  " + hour);
      });
      return timeArray;
    },
    setDisabledDate (array) {
      let self = this;
      this.dateDisableCopy = function (time) {
        let date = "";
        let dateStamp = "";
        let objTime = new Date(time).getTime();
        let disableType = array.some(v => {
          let day = new Date(v.date);
          date =
            day.getFullYear() +
            "-" +
            (day.getMonth() + 1) +
            "-" +
            day.getDate();
          dateStamp = new Date(date).getTime();
          return (
            objTime > new Date().getTime() - 8.64e7 && objTime === dateStamp
          );
        });
        return self.disabledType
          ? disableType || !(objTime > new Date().getTime() - 8.64e7)
          : !disableType;
      };
    },
    filterPastDate () {
      // 在编辑时，修改时间时，将过去已经选择的小于当前日期的日期过滤
      if (this.pageType === "edit") {
        let middleArray = [];
        let sortArray = [];
        this.arrDate.forEach(date => {
          middleArray.push(...getDayAll(date[0], date[1]));
        });
        middleArray = this.uniq(middleArray);
        middleArray.forEach(v => {
          sortArray.push(new Date(v));
        });
        sortArray = sortArray.sort(self.sequence);
        this.arrDate = sortArray.filter(arr => {
          return new Date(arr).getTime() >= new Date().getTime() - 8.64e7;
          return true
        });
      }
    },
    sendDateRange () {
      let self = this;
      this.finallyDate = self.timeFormat(self.successDate);
      this.$emit("selectedCycle", {
        date: self.successDate,
        formatDate: self.timeFormat(self.successDate),
        dateCycle: self.arrDate
      });
      this.showPanel = false;
    }
  },
  components: {
    dateTable,
    timeRange
  },
  watch: {
    receiveData () {
      if (this.receiveDateRange.length > 0) {
        this.arrDate.splice(0, this.arrDate.length, ...this.receiveDateRange);
      }
      if (this.receiveData.length > 0) {
        const receiveData = this.receiveData.filter(
          item => item.time.length > 0
        );
        this.successDate = receiveData;
        this.finallyDate = this.timeFormat(receiveData);
        // this.selectedTime = this.receiveData
        // this.successDate = this.receiveData
        // this.finallyDate = this.timeFormat(this.receiveData)
        this.receiveData.forEach(v => {
          this.selectDate(v.date, "edit");
        });
        this.selectedTime = this.deepClone(this.receiveData)
          .filter(item => item.time.length > 0)
          .map(v => {
            v.time.forEach(timeArr => {
              timeArr[1] = parseInt(timeArr[1]) - 1 + "";
            });
            return v;
          });
      }
      if (this.receiveDateRange.length > 0) {
        this.arrDate.splice(0, this.arrDate.length, ...this.receiveDateRange);
      }
    },
    defaultDate () {
      this.setDisabledDate(this.defaultDate);
    }
  }
};
</script>

<style lang="scss">
.slide-enter-active {
  transition: all 0.3s ease-in;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.date-panel-2 {
  position: relative;
  .selectedDate {
    width: 205px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    box-sizing: border-box;
    color: #0f1a23;
    font-size: 14px;
    outline: 0;
    cursor: pointer;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .selectedDate::-webkit-input-placeholder {
    color: #1d2b36;
  }
  .finallyDate {
    width: 825px;
    padding: 0 10px;
    margin-top: 10px;
    margin-left: 0px;
    background-color: #f9f9f9;
    border-left: 2px solid #eaeaea;
    p {
      /*padding: 3px 0;*/
      white-space: nowrap;
    }
    .final-date-box {
      max-height: 195px;
      max-width: 820px;
      padding: 0 0 5px 0;
      overflow: auto;
    }
  }
  .date-range2 {
    position: absolute;
    top: 35px;
    left: 0px;
    width: 620px;
    padding: 0 10px;
    max-height: 707px;
    min-height: 400px;
    z-index: 100;
    border-radius: 3px 3px;
    background: #fff;
    border-top: 10px solid #0e1922;
    box-shadow: 1px 11px 30px 5px #ccc;
    margin-bottom: 50px;
  }
  .wrapper {
    width: 100%;
  }
  .dateWrapper {
    width: 593px;
    margin: 0 auto;
  }
  h3 {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #0e1922;
    border-radius: 3px 3px 0 0;
    span {
      float: left;
      margin-left: 25px;
      color: #b5c2ca;
    }
    i {
      float: right;
      margin-right: 10px;
      font-size: 30px;
      line-height: 35px;
      color: #ababab;
      cursor: pointer;
    }
  }
  .operatePanel {
    width: 170px;
    height: 345px;
    border-right: 1px solid #f8f8f8;
    .curDate {
      width: 152px;
      height: 28px;
      border: 1px solid #3dc1c4;
      border-radius: 30px 30px;
      margin-top: 15px;
      margin-left: 9px;
      span {
        float: left;
        width: 53px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: #3dc1c4;
        color: #fff;
        border-radius: 30px 0 0 30px;
      }
      .el-input {
        float: left;
        width: 99px;
      }
      .el-input__inner {
        border-color: transparent;
      }
      .el-date-editor .el-input__inner {
        padding: 0 !important;
      }
      input {
        float: left;
        width: 99px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 30px 30px;
      }
    }
  }
  .shortcut {
    width: 161px;
    height: 180px;
    margin-left: 9px;
    margin-top: 30px;
    span {
      display: inline-block;
      height: 22px;
      padding: 0 10px;
      line-height: 22px;
      text-align: center;
      font-size: 12px;
      border-radius: 30px 30px;
      margin-bottom: 10px;
      border: 1px solid #bac6ce;
      cursor: pointer;
      margin-right: 10px;
    }
    span:hover {
      color: #3dc1c4;
      border-color: #3dc1c4;
    }
  }
  .btnGroup {
    /*margin-top: 10px;*/
    button {
      float: right;
      padding: 0;
      width: 50px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      color: #fff;
      border-radius: 3px 3px;
      background: #3dc1c4;
      margin: 0 20px;
      border-color: #3dc1c4;
    }
  }
  .date-range-btn {
    width: 100%;
    margin: 10px 0;
  }
  .borderRight {
    border-right: 1px solid #f1f1f1;
  }
  .disable {
    background-color: #eef1f6;
    border-color: #d1dbe5;
    color: #bbb;
    cursor: not-allowed;
  }
  .disable::-webkit-input-placeholder {
    color: #bbb;
  }
  .timeSelect {
    background: #fff;
    box-shadow: 0 -5px 15px rgba(100, 100, 100, 0.3);
    margin-top: -10px;
  }
}
</style>
